import TagManager from "react-gtm-module";

function CompareNavBar({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "compare_nav_bar",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default CompareNavBar;
